import fetchClient from '@/api/api-client'

import { Coupon } from './types/Coupon'

export async function getCouponByRefUserId(refUserId: string): Promise<Coupon[]> {
  try {
    const res = await fetchClient.post(`/coupons/byrefuserid`, { id: refUserId })
    return res.data.data.response
  } catch (error) {
    throw error
  }
}
